<template>
  <div class="flex justify-between items-center w-full cursor-pointer" @click="handleIntegrationClick">
    <div class="flex items-baseline gap-2">
      <span>{{ formatIntegrationType(integration.type) }}</span>
      <span v-if="botName" class="font-normal text-gray-dark">{{ botName }}</span>
    </div>

    <div class="flex items-center gap-10">
      <span class="font-normal text-gray-dark">
        {{ channelsText }}
      </span>

      <div @click.prevent.stop class="w-12">
        <side-list-menu :items="menuItems"
                        @delete="requestDelete"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SideListMenu from '@/components/common/SideListMenu.vue'
import { MENU_ITEMS } from '@/utils/editor.constants'
import { formatIntegrationType } from '@/utils/integration.utils'

export default {
  name: 'SettingsIntegrationsListTitle',

  props: {
    integration: {
      type: Object,
      required: true
    },
    botNameMap: {
      type: Object,
      default: () => ({})
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },

  components: { SideListMenu },

  emits: ['request-delete', 'select-integration'],

  computed: {
    menuItems() {
      return [MENU_ITEMS.delete]
    },

    botName() {
      if (!this.integration.bot_id) return null
      return this.botNameMap[this.integration.bot_id] || null
    },

    channelsText() {
      const channelsCount = this.integration.channels?.length
      if (!channelsCount) return 'No channels'
      const channelsText = `${channelsCount} channel`
      return channelsCount === 1 ? channelsText : channelsText + 's'
    }
  },

  methods: {
    handleIntegrationClick() {
      this.$emit('select-integration', this.integration)
    },

    formatIntegrationType,

    requestDelete() {
      this.$emit('request-delete', this.integration)
    }
  }
}
</script>

